import { render } from "./MemberList.vue?vue&type=template&id=51c47734&scoped=true"
import script from "./MemberList.vue?vue&type=script&lang=js"
export * from "./MemberList.vue?vue&type=script&lang=js"

import "./MemberList.vue?vue&type=style&index=0&id=51c47734&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c47734"]])

export default __exports__